// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.

<template>
  <div class="error-531">
    <div class="error-531__card">
      <img
        v-if="imgSrc"
        :src="imgSrc"
        class="error-531__img"
        :alt="$t('message.no.panel.access.title')"
      />
      <div class="error-531__description">
        <h1 class="error-531__title">{{ $t('message.no.panel.access.title') }}</h1>
        <p class="error-531__desc">{{ $t('message.no.panel.access.desc') }}</p>
      </div>
      <div class="error-531__actions">
        <a-button class="error-531__btn-back" @click="handleToLogin">
          <arrow-left-outlined />
          {{ $t('label.back.to.login') }}
        </a-button>
        <a-button class="error-531__btn-support" href="https://wa.me/5140035464" target="_blank">
          {{ $t('label.contact.support') }}
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { ArrowLeftOutlined } from '@ant-design/icons-vue'
import authService from '@custom/utils/authService'

export default {
  name: 'Exception531',
  components: { ArrowLeftOutlined },
  computed: {
    imgSrc () {
      return this.$config && this.$config.error && this.$config.error['531']
        ? this.$config.error['531']
        : null
    }
  },
  methods: {
    handleToLogin () {
      authService.performLogout('manual', true)
    }
  }
}
</script>

<style scoped>
.error-531 {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background: #fff;
  padding: 144px 24px 24px;
}

.error-531__card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 600px;
  width: 100%;
  gap: 24px;
}

.error-531__img {
  width: 254px;
  height: 294px;
}

.error-531__description {
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
}

.error-531__title {
  font-size: 24px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
  margin: 0;
  line-height: 32px;
}

.error-531__desc {
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.45);
  line-height: 22px;
  margin: 0;
}

.error-531__actions {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  justify-content: center;
}

.error-531__btn-back {
  width: 162px;
  height: 32px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  padding: 4px 15px;
}

.error-531__btn-support {
  width: 162px;
  height: 32px;
  font-size: 14px;
  font-weight: 400;
  color: #782dc7;
  background: transparent;
  border: none;
  border-radius: 2px;
  padding: 4px 15px;
  box-shadow: none;
}

.error-531__btn-support:hover,
.error-531__btn-support:focus {
  color: #782dc7;
  background: transparent;
  border: none;
  box-shadow: none;
}
</style>
